import React, { useState } from "react";
import "./GenaiOneViewTable.css";
import A1Popup from "./MessageA1Popup";
import ReactDOM from "react-dom";

function GenaiOneViewTable(props) {
    const { setErrors, index,showMaximumChat, setIsShowMaximumChat } = props
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [invoiceHtml, setInvoiceHtml] = useState(""); //GenaiOneViewTable

const [showPopup, setShowPopup] = useState(false);

let item = props?.item?.data ? JSON.parse(props?.item?.data) : {}
    //   if (!item?.text) return null;

    const handledRowButtonClick = (btn, row) => {
        // props?.addMessages(null, btn?.opCode ,btn?.buttonName)}
        if (btn?.buttonType === 'A15') {
            const firstCell = row.innerComponentRowData?.[0] || "";
            props?.addMessages(firstCell, btn?.opCode, btn?.buttonName)
        }
    }

    const showInvoiceColumn = item?.componentRowData?.some(
        (row) => row.isViewInvoiceEligible && row.invoiceData
    );

    //   const data = JSON.parse(item.text);
    const {
        componentHeading,
        componentDesc,
        componentButtonHeading,
        listOfComponentsWithDescAndButtons,
        componentColumnNames,
        componentRowData
    } = item;



    const handleRowSelect = (rowIndex, row) => {
        if (!row?.isSelectedEnabled) return;
    
        // if clicking the same selected row → deselect it
        if (selectedRowIndex === rowIndex) {
            setSelectedRowIndex(null);
    
            setErrors?.((prev) => ({
                ...prev,
                [index]: {
                    key1: "",
                    displayName: ""
                }
            }));
            return;
        }
    
        // else → select the row
        setSelectedRowIndex(rowIndex);
    
        const firstCell = row.innerComponentRowData?.[0] || "";
    
        setErrors?.((prev) => ({
            ...prev,
            [index]: {
                key1: firstCell,
                displayName: firstCell
            }
        }));
    };
    

    // Portal content
    const popupContent = (
        <div className="popup-overlay-oneView" onClick={() => setShowPopup(false)}>
        <div
            className="popup-box-oneView"
            onClick={(e) => e.stopPropagation()} // stop close when clicking inside
        >
             <div
                    className="popup-fullscreen-content"
                    dangerouslySetInnerHTML={{ __html: invoiceHtml }}
                />
            <button className="popup-close" onClick={() => setShowPopup(false)}>
            Close
            </button>
        </div>
        </div>
    );

     /* --------- Small Widget Mode --------- */
  if (!showMaximumChat ) {
    return (
      <div className="a3pack-widget">
        <button
          className="fullscreen-btn"
          onClick={() => setIsShowMaximumChat(true)}
        >
          Click here to open full screen
        </button>
      </div>
    );
  }
    return (
        <div className="oneview-wrapper">

            {/* Component Heading */}
            <h3 className="oneview-heading">{componentHeading}</h3>

            {/* Component Desc */} 
            {componentDesc && (
                <p
                    dangerouslySetInnerHTML={{ __html: componentDesc }}
                />
            )}


            {/* Top Buttons */}
            {componentButtonHeading?.length > 0 && (
                <div className="top-button-container">
                    {componentButtonHeading.map((btn, idx) => (
                        <button
                            key={idx}
                            className="oneview-top-btn action-tab"
                            //   onClick={() => item?.handleButtonClick?.(btn)}
                            onClick={() => props?.addMessages(null, btn?.opCode, btn?.buttonName)}
                        >
                            {btn.buttonName}
                        </button>
                    ))}
                </div>
            )}

            {/* Top Buttons with Headings */}
            {listOfComponentsWithDescAndButtons?.length > 0 && (
                <div className="top-button-with-headings-container">
                    {listOfComponentsWithDescAndButtons.map((details, detailsIdx) => (
                        <div key={detailsIdx}>
                            {Object.entries(details).map(([heading, buttons], idx) => (
                                <div key={`${detailsIdx}-${idx}`}>
                                    {heading && <p className="A3f" dangerouslySetInnerHTML={{__html:heading}}></p>}

                                    {buttons?.length > 0 && (
                                        <div className="top-button-container">
                                            {buttons.map((btn, btnIdx) => (
                                                <button
                                                    key={btnIdx}
                                                    className="oneview-top-btn action-tab"
                                                    onClick={() =>
                                                        props?.addMessages(
                                                            null,
                                                            btn?.opCode,
                                                            btn?.buttonName
                                                        )
                                                    }
                                                >
                                                    {btn.buttonName}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}


            {/* Table */}
            <div className="oneview-table-container">
                <table className="oneview-table">
                    <thead>
                        <tr>
                            {componentColumnNames.map((col, idx) => (
                                <th key={idx}>{col}</th>
                            ))}
                            {showInvoiceColumn && <th>Invoice</th>}
                        </tr>
                    </thead>


                    <tbody>
                        {componentRowData?.map((row, rowIndex) => {
                            const isSelected = selectedRowIndex === rowIndex;
                            const disabledRow = !row?.isSelectedEnabled;

                            return (
                                <>
                                    {/* Main Row */}
                                    <tr
                                        key={rowIndex}
                                        className={`oneview-row 
                                                    ${isSelected ? "oneview-selected" : ""} 
                                                    ${disabledRow ? "oneview-disabled" : ""}
                                                    action-tab`}
                                        onClick={() => handleRowSelect(rowIndex, row)}
                                    >
                                        {/* Normal Columns */}
                                        {row?.innerComponentRowData.map((col, colIdx) => (
                                            <td
                                                key={colIdx}
                                                dangerouslySetInnerHTML={{
                                                    __html: col || "-"
                                                }}
                                            />
                                        ))}

                                        {/* Invoice Column */}
                                        {showInvoiceColumn && (
                                            <td>
                                                {row?.isViewInvoiceEligible && row?.invoiceData ? (
                                                   <span
                                                   className="invoice-link"
                                                   onClick={(e) => {
                                                     e.stopPropagation();
                                                     setInvoiceHtml(row?.invoiceData);
                                                     setShowPopup(true)
                                                   }}
                                                 >
                                                   Invoice
                                                 </span>
                                                 
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        )}
                                    </tr>


                                    {/* Buttons Row (only when row is selected) */}
                                    {rowIndex === selectedRowIndex &&
                                        row?.buttonEnabled?.length > 0 && (
                                            <tr className="oneview-actions-row ">
                                                <td colSpan={showInvoiceColumn
                                                    ? componentColumnNames.length + 1
                                                    : componentColumnNames.length
                                                }>
                                                    <div>
                                                    {
                                                            <span
                                                            key={1}
                                                            dangerouslySetInnerHTML={{
                                                                __html: row?.alert || ""
                                                            }}
                                                        />
                                                        }
                                                    </div>
                                                    <div className="top-button-container">
                                                        {row.buttonEnabled.map((btn, idx) => (
                                                            <button
                                                                key={idx}
                                                                className="oneview-top-btn action-tab"
                                                                onClick={() => handledRowButtonClick(btn, row)}
                                                            >
                                                                {btn.buttonName}
                                                            </button>
                                                           
                                                        
                                                        ))}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                </>


                            );
                        })}
                    </tbody>
                </table>
            </div>
            {showPopup && ReactDOM.createPortal(popupContent, document.body)}


        </div>
    );
}

export default GenaiOneViewTable;
